// src/components/store/sections/newsletter/NewsletterV39MinimalinlineFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV39MinimalinlineFuchsiaGlow(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={39}
      archKey="minimal_inline"
      archLabel="Minimalist Inline Strip"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
